var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCitadel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 29.7",
    style: {
      enableBackground: "new 0 0 28 29.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x35_06-castle.png"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,14v2h-1v-2h-2v2h-1v-2h-2v15.1c2.9,0.1,5.6,0.3,8,0.5V14H26z M26,25h-4v-6h4V25z M15,6V3.8 C16.1,4,17.6,4,19,3c3-2,4-3,4-3s-1,0-4,1c-1.4,0.5-2.9,0.3-4-0.1V0h-2v3v3l-6,6h3v17.1c1.3,0,2.6-0.1,4-0.1s2.7,0,4,0.1V12h3 L15,6z M16,21h-4v-6h4V21z M6,16H5v-2H3v2H2v-2H0v15.7c2.4-0.2,5.1-0.4,8-0.5V14H6V16z M6,25H2v-6h4V25z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitadel);
export default __webpack_public_path__ + "static/media/citadel.3008daa1c029f1eef252fbc2f41cecf4.svg";
export { ForwardRef as ReactComponent };